/* eslint-disable no-underscore-dangle */
import React from 'react';
import { graphql } from 'gatsby';
import get from 'lodash/get';
import {
  Pagination, ArticleTeaser
} from '@comicrelief/component-library';

import Layout from '../../components/Layout/Layout';
import { SEO, SEO_PAGE_TYPES } from '../../components/SEO/SEO';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Paragraphs from '../../components/Paragraphs/Paragraphs';
import { Content, Section } from './PressReleases.styles';

const handleSelect = () => {
  setTimeout(() => {
    const thisElement = document.getElementById('top');
    const position = thisElement.offsetTop
      - thisElement.scrollTop
      + thisElement.clientTop;
    window.scrollTo({
      top: position,
      behavior: 'smooth'
    });
  }, 100);
};

const handlePaginationUrl = (page) => {
  if (page === 1) {
    return '/press-releases/';
  }
  return `/press-releases/page-${page}`;
};

const PressReleases = (props) => {
  const articles = get(props, 'data.allContentfulPageArticle.edges');
  const pageInfo = get(props, 'data.allContentfulPageArticle.pageInfo');
  const {
    paragraphs
  } = get(
    props,
    'data.allContentfulPageLandingPage.edges[0].node'
  );

  const { theme } = get(props, 'pageContext');

  // To match the new IA (Information Architecture) from Numiko:
  const parentPages = [
    { title: 'About Us', path: 'about' },
    { title: 'News', path: 'news' }
  ];
  const thisPageTitle = 'Press Releases';

  return (
    <Layout>
      <Breadcrumb
        thisPageTitle={thisPageTitle}
        parentPages={parentPages}
      />

      {paragraphs && (
      <Paragraphs
        theme={theme}
        paragraphs={paragraphs}
        articles={articles}
      />
      )}

      <Content data-test="press-releases">
        <Section id="top">
          {articles.map(({ node }) => {
            const {
              image, path, displayDate, categories, title, id
            } = node;
            const description = image ? image.title : title;
            const campaign = categories && categories.length > 0 ? categories[0].title : 'default';
            const URL = `/press-releases/${path}`;
            return (
              <ArticleTeaser
                href={URL}
                category={campaign}
                date={displayDate}
                title={title}
                alt={description}
                logoSize="80px"
                key={id}
              />
            );
          })}
        </Section>
        {pageInfo.pageCount > 1 && (
          <Pagination
            disabledBackgroundColor="grey_dark"
            disabledColor="grey_light"
            maxPages={10}
            totalPages={pageInfo.pageCount}
            currentPage={pageInfo.currentPage}
            createURL={value => handlePaginationUrl(value)}
            onSelect={handleSelect}
            showFirst
            showPrevious={false}
            showNext={false}
            showLast
          />
        )}
      </Content>
    </Layout>
  );
};

export default PressReleases;

export const Head = props => (
  <SEO
    allData={props}
    pageType={SEO_PAGE_TYPES.PRESS_RELEASES}
  >
    {(thisSiteUrl, linkedDataObj) => [
      <script type="application/ld+json" key="carousel">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'ItemList',
          itemListElement: linkedDataObj.theseArticleEdges.map((article, position) => ({
            '@type': 'ListItem',
            position,
            url: `${thisSiteUrl}/press-releases/${article.node.path}`
          }))
        })}
      </script>
    ]}
  </SEO>
);

export const pageQuery = graphql`
  query getPress($skip: Int, $limit: Int) {
    allContentfulPageArticle(
      skip: $skip
      limit: $limit
      sort: {displayDate: DESC}
      filter: {type: {eq: "Press Release"}}
    ) {
      totalCount
      pageInfo {
        perPage
        currentPage
        hasPreviousPage
        hasNextPage
        itemCount
        pageCount
      }
      edges {
        node {
          ...ArticleList
        }
      }
    }
    allContentfulPageLandingPage(filter: {path: {eq: "press-releases-content"}}) {
      edges {
        node {
          path
          title
          summary {
            summary
          }
          imageSeo {
            ...Picture
          }
          paragraphs {
            ...PartnerListParagraph
            ...PeopleListParagraph
            ...SingleMessageParagraph
            ...CardsParagraph
            ...FeaturedNewsParagraph
            ...IframeParagraph
            ...CtaSingleCard
            ...CtaMultiCard
            ...DescriptorParagraph
            ...BitesizeParagraph
            ...HTMLParagraph
            ...ImpactSlider
            ...MapParagraph
            ...WhatYourMoneyDoesCarousel
            ...RichtextCarousel
            ...HeroBanner
            ...DynamicGallery
          }
        }
      }
    }
  }
`;
